// JavaScript files are compiled and minified during the build process to the assets/built folder. See available scripts in the package.json file.

// Import CSS
import "../css/index.css";

// Import JS
import menuOpen from "./menuOpen";
import infiniteScroll from "./infiniteScroll";
import lazyImages from "./lazyImages";
import scrollReveal from "./scroll-reveal";
import readingProgress from "./reading-progress";
import stickyCta from "./sticky-cta";
import scrollToTop from "./scroll-to-top";
import headerCompact from "./header-compact";


// Call the menu and infinite scroll functions
menuOpen();
infiniteScroll();
lazyImages();
scrollReveal();
readingProgress();
stickyCta();
scrollToTop();
headerCompact();
